export const printDate = function (date, includeTime = false) {
    if (!date) return "";

    // Dates expected to be in "M/dd/yyyy h:mm tt UTC" format
    if (date.match(/\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d\d (\w\w )?UTC/)) {
        let formatParameters = includeTime
            ? { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }
            : { month: 'numeric', day: 'numeric', year: 'numeric' };
        return new Date(date).toLocaleString('default', formatParameters);
    } else {
        try {
            // Expects DateTimeOffset
            return new Date(parseInt(date.match(/[0-9]+/)[0])).toLocaleString("en-US", { month: 'numeric', day: 'numeric', year: 'numeric' });
        } catch (e) {
            return "";
        }
    }
}

export const printCurrency = function (num) {
    if (typeof num == 'number') {
        num = num.toFixed(2);
    }
    if (!num) {
        return '$0.00';
    } else if (num < 0) {
        return '-$' + Math.abs(num).toFixed(2);
    } else {
        return '$' + num;
    }
}

//export const calcAmountToBePaid = function (toPay, hasPromptPay, promptPayDisc) {
//    if (hasPromptPay) {
//        return (parseFloat((toPay * (1 - hasPromptPay * promptPayDisc / 100))).toFixed(2));
//    } else {
//        return parseFloat(toPay).toFixed(2);
//    }
//}

export const formatAddress = function (address) {
    if (!address) return "";

    return `${address.AddressLine1} ${address.AddressLine2 || ""} ${address.City}, ${address.State} ${address.PostalCode}`;
}